import "@fontsource-variable/inter";
import interUrl from "@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url";
import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/typography.css";
import "./styles/utilities.css";
import "./styles/surfaces.css";
import "./styles/embeds.css";
import "./styles/prose.css";
import {
  isRouteErrorResponse,
  Link,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "react-router";
import Header from "./components/Header/Header.jsx";
import Footer from "./components/Footer/Footer.jsx";
import SkipLink from "./components/SkipLink/SkipLink.jsx";
import Analytics from "./components/Analytics/Analytics.jsx";
import { usePageViews } from "./lib/analytics.js";
import AccessibilityPanel from "./components/AccessibilityPanel/AccessibilityPanel.jsx";

export function links() {
  return [
    { rel: "icon", type: "image/png", sizes: "32x32", href: "/favicon-32.png" },
    { rel: "apple-touch-icon", sizes: "180x180", href: "/favicon-180.png" },
    {
      rel: "preload",
      as: "font",
      type: "font/woff2",
      href: interUrl,
      crossOrigin: "anonymous",
    },
  ];
}

export function Layout({ children }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#101419" />
        <Meta />
        <Links />
        <Analytics />
      </head>
      <body>
        <SkipLink />
        <Header />
        <main id="main" tabIndex={-1}>
          {children}
        </main>
        <Footer />
        <AccessibilityPanel />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  usePageViews();
  return <Outlet />;
}

export function ErrorBoundary({ error }) {
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <section className="section">
      <div className="container">
        <h1>{notFound ? "Page not found" : "Something went wrong"}</h1>
        <p className="lead">
          {notFound
            ? "The page you asked for does not exist or has moved."
            : "Please try again, or contact us if the problem persists."}
        </p>
        {import.meta.env.DEV && error instanceof Error ? <pre>{error.stack}</pre> : null}
        <p>
          <Link to="/" className="btn btn-primary">
            Go to the home page
          </Link>
        </p>
      </div>
    </section>
  );
}
